<template>
<div class="chapter">
<div class="inner_page">
<p class="pn" id="part2"><a id="p72"></a><a id="p73"></a>PART II</p>
<p class="pt-orna"><img alt="images" src="images/pt-ornament.jpg"/></p>
<p class="pt">GAME OF THRONES</p>
<p class="pt-epi"><i>‘When you play the game of thrones, you win or you die. There is no middle ground.’</i></p>
<p class="pt-epi-credit">Cersei Lannister to Eddard Stark, <i>Game of Thrones</i>, series 1, episode 7 (2011)</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part_02.vue?68455b64